import React from "react";
import {
	Box,
	Button,
	Typography,
} from "@mui/material";
import { useMutation } from 'react-query';
import { TextFieldControl } from "@haohan/form-ui"
import { useForm } from "react-hook-form"
import { AuthRegisterInputDTO, AuthRegisterOutDTO } from "@haohan/papi-dto";
import { useNavigate } from "react-router-dom";

import { AuthRegisterFormSuccess } from "./Success";
import { SiteRouterLink } from "../../../../components/RouterLink";
import { useI18n } from "../locales";
import { papi } from "@haohan-frontend/papi";
import { useUrlWithNext } from "../../../utils";

const passswordMinLength = 8;

export function AuthRegisterForm() {
	const [ success, setSuccess ] = React.useState(false);
	const { t } = useI18n();
	const loginURL = useUrlWithNext("/auth/login/");
	const { control, formState, getValues, handleSubmit } = useForm({
		defaultValues: {
			// email: 'asdas@asdas.com',
			// firstName: 'Nikita',
			// lastName: 'Bobrov',
			// password: 'nhjkjkj0',
			// repeatPassword: 'nhjkjkj0'
			email: '',
			firstName: '',
			lastName: '',
			password: '',
			repeatPassword: ''
		},
		mode: 'onBlur',
		reValidateMode: 'onChange'
	});
	const { mutateAsync, isLoading } = useMutation<AuthRegisterOutDTO, void, AuthRegisterInputDTO>(
		data => papi.auth.register(data)
	);
	const submitForm = handleSubmit(async data => {
		const res = await mutateAsync(data);
		if (res.success) {
			setSuccess(true);
		} else {
			if (res.errors.emailExists) {
				control.setError('email', {
					message: t('errors.email_already_exists')
				});
			}
		}
	});
	return (
		<Box position='relative'>
			{success && (
				<AuthRegisterFormSuccess email={getValues().email}/>
			)}
			<form
				onSubmit={submitForm}
				style={{visibility: success ? 'hidden' : 'visible'}}
			>
				<Typography
					color='textSecondary'
					display='block'
					mb={2}
					textAlign='center'
					variant='body2'
				>
					{t('actions.Input information about yourself to create an account')}
				</Typography>
				<TextFieldControl
					control={control}
					fullWidth
					inputMode='text'
					label={t("What's your name?")}
					margin='normal'
					name='firstName'
					rules={{required: t('errors.Required field')}}
					size='small'
					variant='outlined'
				/>
				<TextFieldControl
					autoComplete='username'
					control={control}
					fullWidth
					inputMode='email'
					label='Email'
					margin='normal'
					name='email'
					rules={{
						pattern: {
							value: /\S+@\S+\.\S\S+/,
							message: t('errors.email_invalid')
						},
						required: t('errors.Required field')
					}}
					size='small'
					variant='outlined'
				/>
				<TextFieldControl
					autoComplete='current-password'
					control={control}
					fullWidth
					label={t('Password')}
					margin='normal'
					name='password'
					rules={{
						required: t('errors.Required field'),
						deps: 'repeatPassword',
						minLength: {
							value: passswordMinLength,
							message: t('errors.password_min_length', {count: passswordMinLength})
						}
					}}
					size='small'
					type='password'
					variant='outlined'
				/>
				<TextFieldControl
					autoComplete='current-password'
					control={control}
					fullWidth
					label={t("Repeat password")}
					margin='normal'
					name='repeatPassword'
					rules={{
						required: t('errors.Required field'),
						validate(v) {
							if (getValues().password !== v) {
								return t('errors.password_not_match')
							}
						}
					}}
					size='small'
					type='password'
					variant='outlined'
				/>

				<Box mt={5} mb={1}>
					<Button
						disabled={isLoading}
						fullWidth
						type="submit"
						variant='contained'
					>
						{t('actions.Register')}
					</Button>
				</Box>
				<Box textAlign='center'>
					<Typography color='textSecondary' variant='body2'>
						{t('Already have an account?')}{' '}
						<SiteRouterLink
							to={loginURL}
							underline='hover'
						>
							{t('actions.Sign in')}
						</SiteRouterLink>
					</Typography>
				</Box>
			</form>
		</Box>
	);
}
